import { styleguideService } from "@Shared/Service/StyleguideService";
import { useEffect } from "react";

export const useStyleguideUserPermission = ({ setter }) => {
  useEffect(() => {
    (async () => {
      try {
        const response = await styleguideService.checkPermissionOfUser();
        if (setter) setter(!!response?.data?.permission);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [setter]);
};
